import type { ComponentChildren } from 'preact';

interface ButtonPrimaryProps {
  onClick: () => void;
  children: ComponentChildren;
  disabled?: boolean;
  type?: 'button' | 'submit';
  'aria-label'?: string;
  // eslint-disable-next-line jsx-a11y/no-autofocus
  autoFocus?: boolean;
}

export function ButtonPrimary({
  onClick,
  children,
  disabled = false,
  type = 'button',
  'aria-label': ariaLabel,
  autoFocus = false,
}: ButtonPrimaryProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
      class="w-full py-3 px-6 rounded-lg font-semibold text-white text-base bg-hudson-navy hover:bg-hudson-navy/90 active:bg-hudson-navy/80 focus:outline-none focus:ring-2 focus:ring-hudson-navy focus:ring-offset-2 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
    >
      {children}
    </button>
  );
}
